module.exports = __webpack_public_path__ + "img/logo_ecshopx.b9c2670b.png";